import { render, staticRenderFns } from "./chooseBoxDemo.vue?vue&type=template&id=68685138&scoped=true&"
import script from "./chooseBoxDemo.vue?vue&type=script&lang=js&"
export * from "./chooseBoxDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68685138",
  null
  
)

export default component.exports